import data from "./publication.json";

export const PublicationCreate = data.PublicationCreate;
